export default __webpack_public_path__ + "static/media/logo-mtgovbr-icon.3d73b7de.svg";